import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { SelectItem } from 'primeng/components/common/api';
import { Component, OnInit } from '@angular/core';
import { PromotionTouchPointService } from '../../../services/promotion/promotion-touch-point.service';
import { TouchPointModel } from '../../../models/touch-point.model';
import { LoyaltyParamsService } from '../../../services/loyalty/params.service';
import { TranslateService } from '@ngx-translate/core';
import { Campaign2Service } from '../../../services/campaign-2.0/campaign2.service';

@Component({
  selector: 'kv-promo-touch-point',
  templateUrl: './touch-point.component.html'
})
export class TouchPointComponent implements OnInit {

  public touchPoint: TouchPointModel[];
  public addEditTouchPoint: TouchPointModel;
  ochannel_type_pid;
  chooseAction;
  chooseType;
  touchPointPrivateActions;
  titlePage;
  show = false;
  selectFilter = KontableComponent.SelectFilter;
  touchPointCouponScopes: SelectItem[] = [];
  touchPointActionTypes: SelectItem[] = [];
  touchPointDeployable: SelectItem[] = [];
  touchPointOffline: SelectItem[] = [];

  constructor(
    private srvTouchPoint: PromotionTouchPointService,
    private svcParams: LoyaltyParamsService,
    private srvTranslate: TranslateService,
    private campaignService: Campaign2Service
  ) {
    this.srvTranslate.get([
      'promotion.noAction',
      'promotion.selectTypePid',
      'common.all',
      'common.yes',
    ]).subscribe((res) => {

      this.chooseAction = res['promotion.noAction'];
      this.chooseType = res['promotion.selectTypePid'];


      this.touchPointOffline.push(
        { label: res['common.all'], value: null },
        { label: res['common.yes'], value: '1' },
        { label: 'NO', value: '0' }
      );

    });

    this.svcParams.list(0, 999999, [
      {
        key: 'param_group',
        value: 'TouchPointFlgDeployable'
      }
    ]).subscribe(p => {
      console.log("Dati deployable dal db: ", p.data);
      for (let elem of p.data) {
        this.touchPointDeployable.push({
          label: elem.description,
          value: elem.param_code
        })
      }
    });

    this.svcParams.list(0, 999999, [
      {
        key: 'param_group',
        value: 'TouchPointType'
      }
    ]
    ).subscribe(p => {
      this.ochannel_type_pid = [{ label: this.chooseType, value: null }];
      for (let elem of p.data) {
        this.ochannel_type_pid.push({
          label: elem.description,
          value: elem.id
        })
      }
    });

    this.svcParams.list(0, 999999, [
      {
        key: 'param_group',
        value: 'TouchPointPrivacyAction'
      }
    ]
    ).subscribe(p => {
      this.touchPointPrivateActions = [{ label: this.chooseAction, value: null }];
      for (let elem of p.data) {
        this.touchPointPrivateActions.push({
          label: elem.description,
          value: elem.id
        })
      }
    });

    this.svcParams.list(0, 999999, [
      {
        key: 'param_group',
        value: 'TouchPointCouponScope'
      }
    ]
    ).subscribe(p => {
      for (let elem of p.data) {
        this.touchPointCouponScopes.push({
          label: elem.description,
          value: elem.param_code
        })
      }
    });

    this.svcParams.list(0, 999999, [
      {
        key: 'param_group',
        value: 'TouchPointActionType'
      }
    ]
    ).subscribe(p => {
      for (let elem of p.data) {
        this.touchPointActionTypes.push({
          label: elem.description,
          value: elem.param_code
        })
      }
    });



  }

  ngOnInit(): void {
    this.reloadList()
  }

  showAdd() {
    this.titlePage = 'promotion.addTouchPoint'
    this.addEditTouchPoint = {
      code: '',
      description: '',
      privacyList: [],
      preview_url: '',
      code_preview: '',
      certifier: '',
      flg_no_default: ''
    };
    this.toggleShow()
  }

  delete($event) {
    this.srvTouchPoint.delete($event.id).subscribe(res => {
      this.reloadList();
    });
  }

  reloadList() {
    this.touchPoint = [];
    this.srvTouchPoint.list(0, 999999).subscribe(res => {
      this.touchPoint = res.data;
    });
  }

  showEdit(item) {
    this.srvTouchPoint.get(item.id).subscribe((res) => {
      this.addEditTouchPoint = res;
      this.toggleShow();
    });
    this.titlePage = 'promotion.editTouchpoint';
  }

  toggleShow() {
    this.show = !this.show
  }

  saveTouchPoint(item) {
    const data = {
      code: item.code,
      description: item.description,
      ochannel_type_pid: item.ochannel_type_pid,
      privacyList: !item.privacyList || item.privacyList.length === 0 ? [] : item.privacyList,
      flg_coupon_scope: item.flg_coupon_scope,
      flg_coupon_action: item.flg_coupon_action,
      flg_deployable: item.flg_deployable,
      flg_offline: item.flg_offline,
      preview_url: item.preview_url,
      code_preview: item.code_preview,
      certifier: item.certifier,
      flg_no_default: item.flg_no_default,
      max_reservable_coupons: item.max_reservable_coupons,
      max_usable_coupons: item.max_usable_coupons,
      max_restorable_coupons: item.max_restorable_coupons
    }
    if (!item.id) {
      /*Creazione nuovo touch point SENZA id e SENZA privacyList*/
      this.srvTouchPoint.create(data).subscribe((res: any) => {
        if (item.layout_config) {
          const payload = {
            ochannel_id: res.id,
            json_schema: item.layout_config.json_schema,
            form_schema: item.layout_config.form_schema
          };
          this.campaignService.createTouchpointLayoutConfig(payload).subscribe(() => this.finishSave());
        } else {
          this.finishSave();
        }
      });
    } else {
      /*Modifica touch point esistente CON id e SENZA privacyList*/
      Object.assign(data, { id: item.id });
      this.srvTouchPoint.update(data).subscribe(() => {
        if (item.layout_config) {
          const payload: any = {
            ochannel_id: item.id,
            json_schema: item.layout_config.json_schema,
            form_schema: item.layout_config.form_schema
          };
          let obs;
          if (item.layout_config.id && item.layout_config.ochannel_id === item.id) {
            payload.id = item.layout_config.id;
            obs = this.campaignService.updateTouchpointLayoutConfig(payload);
          } else {
            obs = this.campaignService.createTouchpointLayoutConfig(payload);
          }
          obs.subscribe(() => this.finishSave());
        } else {
          this.finishSave();
        }
      });
    }
  }

  finishSave() {
    this.titlePage = '';
    this.addEditTouchPoint = null;
    this.toggleShow();
    this.reloadList();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/touch-point/touch-point.component.ts